<template>
  <div>
    <div class="face_header">
      <div class="face_header_con">
        <p class="face_header_lf">全能考试系统</p>
        <a class="face_header_rg" @click="logoutHandle">
          <span class="headsp"><img src="@/assets/images/exit.png"/></span>
          退出
        </a>
        <a class="face_header_rg" @click="showPassword">修改密码</a>
        <a class="face_header_rg" @click="resetPasswordHandle">
          <span class="headsp"> <img src="@/assets/images/icon-user.png"/></span
          >{{ userInfo.userName }}
        </a>
      </div>
    </div>
    <updPassword v-if="passwordVisible" ref="updPassword" />
  </div>
</template>

<script>
import { logout, updPwd } from "@/api/login";
import updPassword from "./updPwd";
export default {
  name: "Header",
  components: {
    updPassword
  },
  data() {
    return {
      tokenBean: {
        token: ""
      },
      pwdBean: {
        token: "",
        oldPwd: "",
        loginPwd: ""
      },
      passwordVisible: false,
      loginPwd2: ""
    };
  },
  computed: {
    userInfo() {
      return this.getUserInfo();
    },
    token() {
      return this.getToken();
    }
  },
  methods: {
    logoutHandle() {
      if (confirm("退出确认")) {
        this.tokenBean.token = this.token;
        logout(this.tokenBean).then(res => {
          if (res.code === 200) {
            this.removeUserInfo();
            this.$router.push("/login");
          }
        });
      }
    },
    resetPasswordHandle() {
      this.$router.push("/profile");
    },
    updPwd() {
      if (this.pwdBean.oldPwd === "") {
        this.$message.error("请输入旧密码。");
        return;
      }
      if (this.pwdBean.loginPwd === "") {
        this.$message.error("请输入新密码。");
        return;
      }
      if (this.pwdBean.loginPwd != this.loginPwd2) {
        this.$message.error("新密码与确认密码不一致");
        return;
      }
      this.pwdBean.token = this.token;
      updPwd(this.pwdBean).then(res => {
        if (res.code === 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    showPassword() {
      this.passwordVisible = true;
      this.$nextTick(() => {
        this.$refs.updPassword.initData();
      });
    }
  }
};
</script>

<style scoped></style>
